import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2"; 
import { Api } from "../Api/Api";

export default function ClearedList() {
  const [cleared, setCleared] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCleared();
  }, []);

  const fetchCleared = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${Api}pdf/get_cleared.php`);
      if (res.data.ok) {
        setCleared(res.data.cleared || []);
      }
    } catch (e) {
      console.error("Error fetching cleared PDFs:", e);
    } finally {
      setLoading(false);
    }
  };

  const deletePdf = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This PDF will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(`${Api}pdf/delete_pdf.php`, { id });
          if (res.data.ok) {
            setCleared((prev) => prev.filter((item) => item.id !== id));
            Swal.fire("Deleted!", "The PDF has been deleted.", "success");
          } else {
            Swal.fire("Error", res.data.error || "Delete failed", "error");
          }
        } catch (e) {
          console.error("Error deleting PDF:", e);
          Swal.fire("Error", "Something went wrong while deleting.", "error");
        }
      }
    });
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">Payment Cleared PDFs</h1>

      {loading ? (
        <div>Loading...</div>
      ) : cleared.length === 0 ? (
        <div className="text-gray-500">No cleared items</div>
      ) : (
        <div className="space-y-4">
          {cleared.map((row) => {
            const url = `${Api}pdf/get_pdf.php?id=${row.id}`;
            return (
              <div
                key={row.id}
                className="p-4 border rounded bg-white shadow-sm flex flex-col sm:flex-row sm:items-center sm:justify-between"
              >
                {/* File Details */}
                <div className="mb-3 sm:mb-0">
                  <div className="font-medium">{row.original_name}</div>
                  <div className="text-sm text-gray-500">
                    Uploaded:{" "}
                    {row.uploaded_at
                      ? new Date(row.uploaded_at).toLocaleString()
                      : "-"}
                  </div>
                  <div className="text-sm text-gray-500">
                    Cleared:{" "}
                    {row.cleared_at
                      ? new Date(row.cleared_at).toLocaleString()
                      : "-"}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="px-3 py-1 bg-gray-200 rounded text-center"
                  >
                    View
                  </a>
                  <a
                    href={url}
                    download={row.original_name}
                    className="px-3 py-1 bg-indigo-600 text-white rounded text-center"
                  >
                    Download
                  </a>
                  <button
                    onClick={() => deletePdf(row.id)}
                    className="px-3 py-1 bg-red-600 text-white rounded text-center"
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
